import Button from "olive-react-myoneui/lib/Button";
import { useSelector } from "react-redux";
import RedirectURLObject from "../RedirectURLObject";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { commonModuleName } from "../../constants/config";


function BuyNowButton({ className = false, itemId, itemType = 'course', variant = "secondary" }) {
  const { t } = useTranslation(commonModuleName);
  const navigate = useNavigate();
  const miscellaneous = useSelector((state) => state.user.miscellaneous);
  const buyNowUrlObject = RedirectURLObject({type: "buy_now", redirectTo: `/cart_react?item=${itemType}_${itemId}`});
  var cart = localStorage.getItem("mycart") != null ? JSON.parse(localStorage.getItem("mycart")) : {};
  const index = itemType + '_' + itemId;

  const buyNowRedirect = (buyNowUrlObject) => {
    buyNowUrlObject.isReact ? navigate(buyNowUrlObject.url) : window.location.href = buyNowUrlObject.url;
  }
     
  const BuyNowfn = (id, item_type, learners = {}, other = {}) => {
    cart = localStorage.getItem("mycart") != null ? JSON.parse(localStorage.getItem("mycart")) : {};
    if (typeof cart[index] != "undefined") { 
      buyNowRedirect(buyNowUrlObject);
      return false;
    }
    cart[index] = {
      "id": id,
      "type": item_type,
      "learners": learners,
      "metadata": {},
      "other": other,
    };
    var cart_temp = cart[index];
    var cart_count = Object.keys(cart).length;
    localStorage.setItem("mycart", JSON.stringify(cart));
    localStorage.setItem("mycart_count", cart_count);
    buyNowUrlObject.isReact ? navigate(buyNowUrlObject.url) : window.location.href = buyNowUrlObject.url;
  }

  return(
    <Button
      variant={variant}
      className={className !== false ? className : "w-100 mb-3"}
      size="md"
      onClick={() => BuyNowfn(itemId, itemType)}
      >
      {itemType == 'booking_event' ? t(miscellaneous.event_buy_now_button) : t(miscellaneous.buy_now_button)}
    </Button>
  )
}

export default BuyNowButton;
